import React from 'react';

import { flagStyles } from '../settings';

const SvgBO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-648px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBO;
